import React, {useContext, useRef} from 'react';
import propTypes from 'prop-types';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';

const LargeQuote = ({ elClass, quote, source, imgSrc }) => {
	const { data: {content} } = useContext(Context);
	
	const largeQuoteContainer = useRef(null);

	useGSAP(
		() => {
			const tl = gsap
				.timeline()
				.from(`.${elClass}__quote`, {
					opacity: 0,
				})
				.from(`.${elClass}__citation`, {
					opacity: 0,
				});

			ScrollTrigger.create({
				trigger: largeQuoteContainer.current,
				start: "center center+=40%",
				end: "+=140",
				scrub: 2,
				animation: tl,
			});
		},
		{ scope: largeQuoteContainer.current, dependencies: [content.chapters] }
	);

	return (
		<div className={`${elClass} main-grid`} ref={largeQuoteContainer}> 
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<p 
					className={`${elClass}__quote purple-quote hanging-quotation-mark`}
					dangerouslySetInnerHTML={{__html: `&ldquo;${quote}&rdquo;`}}
				></p>
				<cite 
					className={`${elClass}__citation quote-attribute`}
					dangerouslySetInnerHTML={{__html: source}}
				></cite>
				<img className={`${elClass}__bg-shape bg-shape`} src={imgSrc} alt="" loading="lazy" />
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default LargeQuote;

LargeQuote.propTypes = {
	quote: propTypes.string.isRequired,
	source: propTypes.string.isRequired,
	imgSrc: propTypes.string,
	elClass: propTypes.string.isRequired
}
